/* ─────────────────────────────────────────────────────────────────────────────
   GrowthOS migration — Retention (KAM) dashboard — RTK Query slice. Real data:
   brand health status + cohort curves come from growthos_revenue_daily (rolled
   up from live MongoOrder data).
   ──────────────────────────────────────────────────────────────────────────── */
import { createApi } from '@reduxjs/toolkit/query/react'
import { apiConstants, get } from '../common/constants'

const RETENTION = apiConstants.GROWTHOS_ADMIN_RETENTION

const run = async (promise) => {
  try {
    const res = await promise
    return { data: res?.data }
  } catch (err) {
    const r = err?.response
    return {
      error: {
        status: r?.status,
        data: r?.data,
        message: r?.data?.message || err.message,
      },
    }
  }
}

export const growthosRetentionApiSlice = createApi({
  reducerPath: 'growthosRetentionApi',
  baseQuery: () => ({ data: undefined }),
  tagTypes: ['Retention'],
  endpoints: (b) => ({
    getRetentionDashboard: b.query({
      queryFn: ({ period, from, to }) => run(get(RETENTION, { period, from, to })),
      providesTags: ['Retention'],
    }),
  }),
})

export const { useGetRetentionDashboardQuery } = growthosRetentionApiSlice
